import { BI_METADATA_API_BASE_URL_V7 } from '../config';
import type { WorkspaceTypeID } from '../workspaces';

const baseURL = `${BI_METADATA_API_BASE_URL_V7}/studio_filter_configuration`;

export interface GetFilterConfigParams {
  fileName?: string;
  workspaceTypeID?: WorkspaceTypeID;
}
export const FilterConfigAPIRoutes = {
  getFilterConfig: () => {
    return baseURL;
  },
};
